import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Slider from 'component/Layout/Slider';
import Toggle from 'component/Layout/Toggle';

import { Swiper } from 'swiper';
import SwiperClass from 'swiper/types/swiper-class';

import useCookie from 'hooks/useCookie';

import { ReactComponent as IconChevronRounded } from 'media/svg/chevronRounded.svg';

import { ChatBotData } from 'proto/ChatBotData';
import { TravelExpertList } from 'proto/TravelExpert/TravelExpert';

import Chat from './__partials/Chat';
import Expert from './__partials/Expert';
import Trust from './__partials/Trust';

import styles from './Card.module.scss';

export interface ExpertCardProps {
    expert: TravelExpertList;
    chatBotData?: ChatBotData;
    customClass?: string;
    serviceCode?: string;
}

const ExpertCard = ({
    customClass = '',
    expert,
    serviceCode,
    chatBotData,
}: ExpertCardProps) => {
    const { t } = useTranslation();
    const [cookie, updateCookie] = useCookie(
        'lastSeen',
        `${expert?.items[0]?.idHash}`
    );
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const classList = `${styles.Card} ${customClass}`;
    const hasExpert = !!expert?.items.length;
    const currExpertSlideFromCookie = expert?.items.find((item, index) => {
        return item.idHash === cookie && index;
    });

    const settings = {
        pagination: false,
        initialSlide: currExpertSlideFromCookie || 0,
    };
    const onSlideChange = (swiper: Swiper) => {
        setCurrentIndex(swiper.realIndex);
    };

    useEffect(() => {
        const currentExpertHash =
            expert?.items[currentIndex]?.idHash.toString() || cookie;
        if (cookie !== currentExpertHash) {
            updateCookie(currentExpertHash);
        }
    }, [cookie, currentIndex, expert, updateCookie]);

    let slides = [] as JSX.Element[];
    if (
        !!expert &&
        (expert?.items.length > 1 || (hasExpert && !!chatBotData))
    ) {
        slides = expert?.items.map((current, index) => {
            return (
                <Expert
                    expert={current}
                    serviceCode={serviceCode}
                    key={index}
                />
            );
        });
        if (!!chatBotData) {
            slides.push(
                <Chat chatBot={chatBotData} key={expert?.items.length + 1} />
            );
        }
    }
    if (!chatBotData && !hasExpert) {
        return null;
    }
    return (
        <>
            <div className={classList}>
                {!chatBotData && expert?.items.length === 1 && (
                    <Expert
                        expert={expert?.items[0]}
                        serviceCode={serviceCode}
                    />
                )}
                {!!chatBotData && !hasExpert && <Chat chatBot={chatBotData} />}
                {!!slides?.length && (
                    <Slider
                        settings={{
                            ...settings,
                        }}
                        classListObject={{
                            SliderWrapper: styles.SliderWrapper,
                            PrevButton: styles.PrevButton,
                            NextButton: styles.NextButton,
                        }}
                        onSlideChangeCallback={(swiper: SwiperClass) =>
                            onSlideChange(swiper)
                        }
                    >
                        {slides?.map((slide) => {
                            return slide;
                        })}
                    </Slider>
                )}
                {currentIndex !== expert?.items.length && (
                    <Toggle
                        customClassList={{
                            Toggle: styles.Toggle,
                            More: styles.More,
                            Open: styles.Open,
                        }}
                        opener={t('TRANS-more')}
                        closer={t('TRANS-less')}
                        icon={<IconChevronRounded />}
                        hiddenChild={
                            <div>
                                <Trust />
                            </div>
                        }
                    />
                )}
            </div>
        </>
    );
};

export default ExpertCard;
